import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { Route } from 'react-router-dom';
import { RequestPasswordResetViewModel } from '../../Screen/RequestPasswordReset/RequestPasswordResetViewModel';
import { RequestPasswordResetViewController } from '../../Screen/RequestPasswordReset/RequestPasswordResetController';


export class RequestPasswordResetCoordinator implements IndexCoordinatorDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeRequestPasswordReset(),
        ];
    }

    private routeRequestPasswordReset(): JSX.Element {
        const viewModel = new RequestPasswordResetViewModel();
        return (
            <Route path="/:base/email-redefinir-senha" exact={true} component={(props: any) => {
                    const token = props.match.params.token;
                    return (
                        <RequestPasswordResetViewController
                            navigation={props}
                            viewModel={viewModel}
                            token={token}
                            delegate={this}
                        />
                    );
                }}
            />
        );
    }
    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
}
